// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "story-module--base-text-alt--global--8702f";
export var baseTextGlobal = "story-module--base-text--global--9397b";
export var blockSpacing100 = "story-module--block-spacing-100--12544";
export var blockSpacing50 = "story-module--block-spacing-50--15d27";
export var blockVPadding100 = "story-module--block-v-padding-100--22b25";
export var blockVPadding50 = "story-module--block-v-padding-50--774b2";
export var body = "story-module--body--555f4";
export var captionTextGlobal = "story-module--caption-text--global--b2439";
export var cmsRenderedContentGlobal = "story-module--cms-rendered-content--global--9c38c";
export var container = "story-module--container--215fb";
export var defaultHSpacingGlobal = "story-module--default-h-spacing--global--668a3";
export var fadeInAnimation = "story-module--fadeInAnimation--7f479";
export var fadeInOnLoadGlobal = "story-module--fade-in-on-load--global--c17dd";
export var fullHeightGlobal = "story-module--full-height--global--5474a";
export var fullHeightOmittingNavGlobal = "story-module--full-height-omitting-nav--global--35d59";
export var headingTextGlobal = "story-module--heading-text--global--9bff9";
export var ingressTextGlobal = "story-module--ingress-text--global--0f747";
export var linkColorChangeTransitionGlobal = "story-module--link-color-change-transition--global--55614";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "story-module--page-heading-text--global--1f4b2";
export var paragraphTextGlobal = "story-module--paragraph-text--global--74dda";
export var storiesContainer = "story-module--storiesContainer--f6090";
export var storyContainer = "story-module--storyContainer--4f509";
export var subheadingTextGlobal = "story-module--subheading-text--global--07277";
export var title = "story-module--title--b27e1";